import React from 'react';

import NavigationButtons from './navigation_buttons';
import PanelStylesApplicator from './panel_styles_applicator';
import CloseLayer from './close_layer';

const FloatingNavigation = () => (
  <div className="floating-nav">
    <PanelStylesApplicator />
    <NavigationButtons />
    <CloseLayer />
  </div>
);

export default FloatingNavigation;
